import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
export interface TemplateDoctorNotesInterface {
    templateDoctorNoteId: number
    templateName: string
    url: string
    isDefault: string
    status: string
    updatedBy: string
    updatedAt: Date
    createdBy: string
    createdAt: Date
}

const path = `template-doctor-notes`

export default class TemplateDoctorNotesApi extends BaseAPI {
    static findAll(props: FindAllInterface): Promise<any> {
        return this.api.get(path, { params: { ...props } })
    }
    static create(payload: any) {
        return this.api.post(path, payload)
    }
    static findById(id: number): Promise<TemplateDoctorNotesInterface> {
        return this.api.get(`${path}/${id}`)
    }
    static update(id: number, body: any) {
        return this.api.patch(`${path}/${id}`, body)
    }
    static updateStatus(id: number, status: string): Promise<any> {
        return this.api.patch(`${path}/${id}/status`, { id, status })
    }
    static remove(id: number) {
        return this.api.delete(`${path}/${id}`)
    }
}
